import { Box, InlineStack, Link, Text } from '@shopify/polaris';
import { useTranslation } from 'react-i18next';

const Footer = () => {
    const { t } = useTranslation();
    return (
        <Box paddingBlock={'800'}>
            <InlineStack gap={'200'} align="center" blockAlign="center">
                <Text as="p" variant="bodySm">
                    {t('DASHBOARD.HELP')}
                </Text>
                <Link url={'mailto:support@digiloop.io'} target={'_blank'}>
                    <Text as="p" variant="bodySm">
                        {t('DASHBOARD.CONTACT_US')}
                    </Text>
                </Link>
            </InlineStack>
        </Box>
    );
};

export default Footer;
